import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Icon, Popup } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import { SketchPicker } from 'react-color';

import { isValidColorString } from 'components/modules/colors/services/colors';

import { ColorPropTypes } from './ColorPicker.propTypes';
import { getColorString, getColorValue } from './ColorPicker.utils';

import './ColorPicker.scss';

const propTypes = {
  color: ColorPropTypes.isRequired,
  onSelect: PropTypes.func.isRequired,
  disableAlpha: PropTypes.bool,
  withPopUpWrapper: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  disableAlpha: false,
  withPopUpWrapper: false,
  disabled: false,
};

export default function ColorPicker({ color, onSelect, withPopUpWrapper, disableAlpha, disabled }) {
  const [displayPicker, setDisplayPicker] = useState(false);

  function onChangeComplete(pickedColor) {
    onSelect(pickedColor);
  }

  function onPopupTrigger(event) {
    event.preventDefault();
    setDisplayPicker(true);
  }

  const backgroundColor = getColorString(color);

  const pickerTrigger = (
    <Button className="color-picker-trigger" onClick={onPopupTrigger} disabled={disabled}>
      <div className="color-picker-color" style={{ backgroundColor }}>
        {(_isEmpty(backgroundColor) || !isValidColorString(backgroundColor)) && (
          <Icon name="paint brush" />
        )}
      </div>
    </Button>
  );

  const colorPicker = (
    <SketchPicker
      onChangeComplete={onChangeComplete}
      color={getColorValue(color)}
      width="auto"
      disableAlpha={disableAlpha}
    />
  );

  if (withPopUpWrapper) {
    return (
      <Popup
        size="huge"
        wide
        content={displayPicker ? colorPicker : null}
        on="click"
        pinned
        position="right center"
        trigger={pickerTrigger}
      />
    );
  }

  return colorPicker;
}

ColorPicker.propTypes = propTypes;
ColorPicker.defaultProps = defaultProps;
